import { useNavigate } from "react-router-dom";

/**
 * The main hook for the App Navigation.
 * @returns The navigateTo function.
 */
const useAppNavigation = () => {
  const navigate = useNavigate();

  /**
   * Navigates to the desired string path.
   * @param path The path desired to navigate to.
   */
  const navigateTo = (
    path: string,
    params?: {
      state?: {
        [key: string]: boolean | string | number | object | undefined;
      };
      // Replace the current history entry, so the browser's Back button
      // can't return to the page being left
      replace?: boolean;
    }
  ): void => {
    navigate(path, { ...params });
  };

  return {
    navigateTo,
  };
};

export default useAppNavigation;
